export default __webpack_public_path__ + "static/media/about-us-3.da3e675e.png";